<template>
  <layout-basic>
    <v-container grid-list-md text-xs-left fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card flat>
            <v-card-text class="px-3">
              <h1>Help Section</h1>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs3>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 4 : 0}`"
              flat
              class="text-xs-center px-0 mx-auto"
              to="/admin/help/faq"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  src="/static/page-icons/Web_Icons_FAQs_Purple.png"
                ></v-img>
                <h3>FAQs</h3>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs3>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 4 : 0}`"
              flat
              class="text-xs-center px-0 mx-auto"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  src="/static/page-icons/Web_Icons_How to Guide_Green.png"
                ></v-img>
                <h3>How to Guides</h3>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs3>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 4 : 0}`"
              flat
              class="text-xs-center px-0 mx-auto"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  src="/static/page-icons/Web_Icons_Help Desk_Red.png"
                ></v-img>
                <h3>Help Desk</h3>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
        <v-flex xs3>
          <v-hover>
            <v-card
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 4 : 0}`"
              flat
              class="text-xs-center px-0 mx-auto"
            >
              <v-card-text>
                <v-img
                  width="120px"
                  height="120px"
                  position="center"
                  style="margin:0 auto"
                  contain
                  src="/static/page-icons/Web_Icons_Suggest a Course_Blue.png"
                ></v-img>
                <h3>Suggest A Course</h3>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from "@/layouts/Dashboard";
export default {
  components: {
    LayoutBasic
  }
};
</script>
